import { API_URL } from '../../config';

export const resolveScreenshotSrc = (value?: string | null): string | null => {
  if (!value || typeof value !== 'string') {
    return null;
  }

  if (value.startsWith('data:') || value.startsWith('http://') || value.startsWith('https://')) {
    return value;
  }

  // The session cookie carries the active org; no per-request org context needed.
  return `${API_URL}/screenshots/${encodeURIComponent(value)}`;
};

